export const QuestionSetConstants = {
    SECTION_A: 'B5BB24A8-E3AA-4742-BF24-EBDE6DCF773E',
    SECTION_B1: '11951CC0-9D05-45A1-8821-4D7FE2A5C868',
    SECTION_B2: '77E89C9C-30E7-484B-8C2C-56CE0003C2FE',
    SECTION_C: '6E2D63B4-2ECB-4F1F-BDC1-07D1CB8A6166',
    SECTION_D: '832B7251-79A6-4B58-A19B-93B371CC0C9F'
}